import type { AcademicSession, AttendanceToken } from './types'

export function nextAttendanceQr(previous: AttendanceToken | undefined, incoming: AttendanceToken | undefined, session: AcademicSession | undefined): AttendanceToken | undefined {
  if (!session || session.status !== 'ACTIVE') return undefined
  const usable = (token: AttendanceToken | undefined): token is AttendanceToken => Boolean(token && token.token && token.sessionId === session.id && Number.isFinite(token.issuedAt) && token.expiresAt > token.issuedAt)
  if (!usable(incoming)) return usable(previous) ? previous : undefined
  return usable(previous) && previous.issuedAt >= incoming.issuedAt ? previous : incoming
}

// Expiry is NOT extended. An expired last QR may remain visible during a network
// failure, but Apps Script will reject a new scan until a fresh token arrives.
export function attendanceQrForSession(tokens: AttendanceToken[], session: AcademicSession | undefined) {
  return tokens.reduce<AttendanceToken | undefined>((latest, token) => nextAttendanceQr(latest, token, session), undefined)
}
